import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const completedConfig = {
    name: 'kpi.instagram.stories.completed',
    id: 'new_completed',
    icon: {
        name: 'completion-rate',
        style: colors.green
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
